import { IState } from '../../store';

export const selectIsSmsVerificationModalOpen = (state: IState) => state.requestDemand.isSmsVerificationModalOpen;
